import React from 'react';
import FontAwesome from 'react-fontawesome';
import FilterBar from 'components/core/FilterBar';
import { Nav, NavItem } from 'react-bootstrap';


const SalesTargetFilter = (props) => {
  
  const {
    currentYear,
    handlePrev,
    handleNext
  } = props;
  
  return (
    <FilterBar>
      <Nav>
        <NavItem onClick={handlePrev}>
          <FontAwesome name="chevron-left" className="mr-10" />Prev Year
        </NavItem>
        <NavItem disabled={true}>{currentYear}</NavItem>
        <NavItem onClick={handleNext}>
          Next Year<FontAwesome name="chevron-right" className="ml-10" />
        </NavItem>
      </Nav>
    </FilterBar>
  );
}

export default SalesTargetFilter;